import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useAboutPage, getAboutSectionByKey } from '@/hooks/useAboutPage';

const Statistics = ({ sectionData: propSectionData }) => {
  const { sections, loading } = useAboutPage();
  const statisticsSection = propSectionData || getAboutSectionByKey(sections, 'statistics');
  
  const bgColor = statisticsSection?.background_color || 'light';
  const bgEffect = statisticsSection?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  
  if (loading && !propSectionData) {
    return (
      <section className={`py-5 py-lg-6 ${bgClass} about-section statistics-section`}>
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Container>
      </section>
    );
  }
  
  const statistics = statisticsSection?.items || [];
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';
  
  if (statistics.length === 0) {
    return null;
  }
  
  return (
    <section className={`py-5 py-lg-6 ${bgClass} about-section statistics-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        <Row className="g-4">
          {statistics.map((stat, idx) => {
            const number = stat.content?.number || stat.title;
            const description = stat.description || '';
            const label = stat.title || '';
            
            return (
              <Col md={6} lg={3} key={stat.id || idx}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="p-4 p-lg-5">
                    <h3 className="display-5 fw-bold text-primary mb-3">{number}</h3>
                    {description && (
                      <p className="mb-2" style={{ color: '#495057', lineHeight: '1.6' }}>{description}</p>
                    )}
                    {label && (
                      <h6 className="mb-0 fw-bold" style={{ color: '#000000' }}>{label}</h6>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Statistics;

